import { ApiClient } from "@equidefi/portals/clients";

class IntercomClient extends ApiClient {
  async createTicket(data) {
    const response = await this.post(`/v2/support/ticket/`, data);
    return response.data;
  }

  async getTicketTypes() {
    const response = await this.get(`/v2/support/ticket-types/`);
    return response.data;
  }
}

export default IntercomClient;
